module.exports = __webpack_public_path__ + "media/jjooJuventud.c1f1c45a.mp4";